import { useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import { Navigate } from "react-router-dom";
import { history } from "../helpers/history";
import Sidebar from "../components/Sidebar";

function PrivateRoute({ children }) {
  const { user, register } = useContext(AuthContext);

  //console.log(register);

  if (!user) {
    return <Navigate to="/login" state={{ from: history.location }} />;
  }

  if (!register) {
    return <Navigate to="/signup" state={{ from: history.location }} />;
  }

  return (
    <>
      <Sidebar ruta={history.location.pathname} />
      <section className="content-fluid">{children}</section>
    </>
  );

  /*
    if(user && (history.location.pathname === "/dashboard")) {
        return children
    } else {
        return (<>
                <Sidebar ruta={history.location.pathname}/>
                <section className='content'>
                   {children}
                 </section>
            </>)
      }
      */
}
function NoAllowAuthUsers({ children }) {
  const { user } = useContext(AuthContext);
  if (user) {
    return <Navigate to="/" state={{ from: history.location }} />;
  }
  return children;
}
export { PrivateRoute, NoAllowAuthUsers };
